/**
 * Detects whether the current browser is an in-app browser / embedded webview
 * that Google blocks with 403 disallowed_useragent.
 *
 * Google's "Use secure browsers" policy blocks OAuth from embedded user-agents
 * including Facebook, Instagram, TikTok, LinkedIn, Snapchat, and generic WebViews.
 *
 * NOTE: The same UA blocklist is duplicated inline in
 * src/app/plugin-autologin/external-signup-form-with-tracking.html (vanilla JS
 * embed cannot import this module). Keep both lists in sync when modifying.
 */

const IN_APP_UA_PATTERNS = [
  /FBAN|FBAV|FB_IAB/i,        // Facebook / Messenger
  /Instagram/i,                // Instagram
  /musical_ly|BytedanceWebview|TikTok/i, // TikTok
  /LinkedInApp/i,              // LinkedIn
  /Snapchat/i,                 // Snapchat
  /Twitter|TwitterAndroid/i,   // X / Twitter
  /Line\//i,                   // LINE
  /KAKAOTALK/i,                // KakaoTalk
  /\bwv\b/i,                   // Android WebView ("; wv)" token)
  /GSA\//i,                    // Google Search App (older versions)
];

/**
 * Returns true if the current user-agent matches a known in-app browser
 * that Google will block with disallowed_useragent.
 */
export function isInAppBrowser() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return IN_APP_UA_PATTERNS.some(pattern => pattern.test(ua));
}
